import { inject, Injectable } from '@angular/core';
import { EMPTY } from 'rxjs';
import { CustomErrorHandlerService } from '../..';

@Injectable({
    providedIn: 'root',
})
export class ErrorHandlingService {
    private readonly customErrorHandler = inject(CustomErrorHandlerService);

    public catchError(err: Error): typeof EMPTY {
        this.customErrorHandler.handleError(err);

        return EMPTY;
    }
}
